module.exports = __webpack_public_path__ + "static/media/reservations.f12c50ca.svg";